var map = {
	"./Mysql.png": "eb2c",
	"./Oracle.png": "c009",
	"./PostgreSQL.png": "733d",
	"./SQLServer.png": "5e7d",
	"./cabinet.png": "f5f3",
	"./columns.png": "24c1",
	"./database.png": "aa99",
	"./document-2.png": "e1f2",
	"./document.png": "5069",
	"./ds-background.png": "5eba",
	"./folder-2.png": "18f8",
	"./folder-3.png": "880d",
	"./folder.png": "d6aa",
	"./key-2.png": "a2be",
	"./key-primary.png": "27b1",
	"./key.png": "b738",
	"./menu-2.png": "15a2",
	"./menu.png": "7738",
	"./table.png": "9af9",
	"./user.png": "0f71",
	"./users.png": "1781"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";